import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { identitySchema, publishedAtSchema } from '@/core/components';

const identifiersSchema = z.object({
  wosId: z.string().nullable(),
  doi: z.string().nullable(),
  scopusId: z.string().nullable(),
  wosLink: z.string().nullish(),
  scopusLink: z.string().nullish(),
});

export const publicationSchema = z.object({
  title: z.string().min(5),
  language: identitySchema,
  noOfPages: z.number().min(0).max(9000),
  publishedAt: publishedAtSchema,
  wosIndexes: z.array(identitySchema),
  wosCategories: z.array(identitySchema),
  bdis: z.array(identitySchema),
  identifiers: identifiersSchema,
  startPage: z.number().min(0).max(9000),
  endPage: z.number().min(0).max(9000),

  sourceType: z.string().nullish(),
  universityAffiliatedNoOfAuthors: z.number().nullish(),
  noOfRoAuthors: z.number().nullish(),

  link: z.union([z.literal(''), z.literal(null), z.string().trim().url()]),
});

export const defaultPublicationValues: DefaultValues<PublicationSchema> = {
  title: '',
  wosIndexes: [],
  wosCategories: [],
  identifiers: {
    wosId: '',
    doi: '',
    scopusId: '',
    scopusLink: '',
    wosLink: '',
  },
  sourceType: 'MANUAL',
  bdis: [],
  link: '',
};

export type PublicationSchema = z.infer<typeof publicationSchema>;
